export const INDICATOR_BADGE_PLACEMENT = {
    BOTTOM_RIGHT: 'bottom-right',
    TOP_RIGHT: 'top-right',
};
